//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

// ACTION TYPES
export const GET_CONFIGURATION_SESSION_STARTS = "GET_CONFIGURATION_SESSION_STARTS";
export const GET_CONFIGURATION_SESSION_SUCCESS = "GET_CONFIGURATION_SESSION_SUCCESS";
export const INITIAL_STATE_CONFIGURATION_SESSION = "INITIAL_STATE_CONFIGURATION_SESSION";
export const SET_USER_FUNCTIONS_CONFSESIONVISTA = 'SET_USER_FUNCTIONS_CONFSESIONVISTA';
export const RESET_STATE_CONFIGSESIONVISTA = 'RESET_STATE_CONFIGSESIONVISTA';

let _currentScope = null;
let _dispatch = null;

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} currentScope
 */
export function searchConfigurationSession(currentScope) {
    LogHelper.In(searchConfigurationSession.name, currentScope);

    return (dispatch, getState) => {
        _currentScope = currentScope;
        _dispatch = dispatch;
        dispatch({ type: GET_CONFIGURATION_SESSION_STARTS });

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenData(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }

    LogHelper.Out(searchConfigurationSession.name, currentScope);
}

export function resetStateConfigSesionVista() {
    LogHelper.In(resetStateConfigSesionVista.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_STATE_CONFIGSESIONVISTA });
    }
}


/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

/**
 * Funcion callback de los datos principales para popular la pantalla.
 * @param {any} data
 */
function _loadScreenData(data) {
    LogHelper.In(_loadScreenData.name, data);

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_USER_FUNCTIONS_CONFSESIONVISTA, functions });
    
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_TIPO_PLATAFORMA', "Get", _currentScope.ProductCode, "SEGURIDAD", "Product", 1);
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_CONFIGURATION_PASSWORD_SESION', "Get", _currentScope.ProductCode, "SEGURIDAD", "Product", 1);
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_CONFIGURATION_PASSWORD_TYPE', "Get", _currentScope.ProductCode, "SEGURIDAD", "Product", 1);

    Engine1Proxy.Execute(_loadUserListInitialStateData, null, null, "SEGURIDAD");

    LogHelper.Out(_loadScreenData.name, data);
}

/**
 * Funcion que parsea los datos recibidos del Engine1 para retornarlos a pantalla.
 * @param {any} data
 */
function _loadUserListInitialStateData(data) {
    LogHelper.In(_loadUserListInitialStateData.name, data);

    let result = {
        "GET_TIPO_PLATAFORMA": JSON.parse(data.GET_TIPO_PLATAFORMA).Recordset0.Rows,
        "GET_CONFIGURATION_PASSWORD_SESION": JSON.parse(data.GET_CONFIGURATION_PASSWORD_SESION).Recordset0.Rows,
        "GET_CONFIGURATION_PASSWORD_TYPE": JSON.parse(data.GET_CONFIGURATION_PASSWORD_TYPE).Recordset0.Rows
    }
    _dispatch({ type: GET_CONFIGURATION_SESSION_SUCCESS, result: result });

    LogHelper.Out(_loadUserListInitialStateData.name, data);
}